import { Mesh, MeshLambertMaterial } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/team2/SubTopic3/GLB_CafeteraKobalto_Proceso_V3.glb";
import { GUI } from "dat.gui";
import { gsap } from "gsap";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";

export class CafeteraKobaltoProceso extends Mesh {
	constructor(camera, loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		this.camera = camera;
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		this.objectsMaterials = {
			beforeCafetera: null,
			beforeKeyMachine: null,
			keyMachine: null,
			beforeMostrador: null,
			keyMostrador: null,
		};
		this.stepActiveAnimation = 0;
		this.observerListtneners();
		// this.helpers();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			// gltf.scene.visible = false;
			this.Mostrador = gltf.scene.getObjectByName("Mostrador", true); // tooltip
			this.BotonesDeSeleccion = gltf.scene.getObjectByName("BotonesDeSeleccion", true); // tooltip
			this.CharolaPortaVaso = gltf.scene.getObjectByName("CharolaPortaVaso", true); // tooltip
			this.ContenedorDeGrano = gltf.scene.getObjectByName("ContenedorDeGrano", true); // tooltip
			this.Dispensador001 = gltf.scene.getObjectByName("Dispensador001", true); // tooltip
			this.Garrafon001 = gltf.scene.getObjectByName("Garrafon001", true);
			this.Llave001 = gltf.scene.getObjectByName("Llave001", true); // fisico
			this.Llave003 = gltf.scene.getObjectByName("Llave003", true); // tooltip
			this.Pantalla = gltf.scene.getObjectByName("Pantalla", true); // tooltip
			this.Puerta_Mostrador = gltf.scene.getObjectByName("Puerta_Mostrador", true);
			this.Cafetera001 = gltf.scene.getObjectByName("Cafetera001", true);
			this.Cafetera_puerta = gltf.scene.getObjectByName("Cafetera_puerta", true);
			this.Cafetera_contenedores_puerta = gltf.scene.getObjectByName("Cafetera_-_contenedores_-_puerta", true); // nombre cambiado
			this.Cafetera_letrero_andati = gltf.scene.getObjectByName("Cafetera_-_letrero_andati", true); // nombre cambiado
			this.CodoContenedor01001 = gltf.scene.getObjectByName("CodoContenedor01001", true);
			this.CodoContenedor02001 = gltf.scene.getObjectByName("CodoContenedor02001", true);
			this.CodoContenedor03001 = gltf.scene.getObjectByName("CodoContenedor03001", true);
			this.contenedor01Paso2001 = gltf.scene.getObjectByName("contenedor01-Paso2001", true); // nombre cambiado
			this.contenedor01Paso1001 = gltf.scene.getObjectByName("contenedor01-Paso1001", true); // nombre cambiado
			this.contenedor02Paso2001 = gltf.scene.getObjectByName("contenedor02-Paso2001", true); // nombre cambiado
			this.contenedor02Paso1001 = gltf.scene.getObjectByName("contenedor02-Paso1001", true); // nombre cambiado
			this.contenedor03Paso2001 = gltf.scene.getObjectByName("contenedor03-Paso2001", true); // nombre cambiado
			this.contenedor03Paso1001 = gltf.scene.getObjectByName("contenedor03-Paso1001", true); // nombre cambiado
			// console.log(this.contenedor03Paso2001);
			this.add(gltf.scene);

		});
	}

	hiddenChild() {
		this.BotonesDeSeleccion.visible = false;
		this.CharolaPortaVaso.visible = false;
		this.ContenedorDeGrano.visible = false;
		this.Dispensador001.visible = false;
		this.Llave001.visible = false;
		this.Llave003.visible = false;
		this.Pantalla.visible = false;
		this.contenedor01Paso1001.visible = false;
		this.contenedor02Paso1001.visible = false;
		this.contenedor03Paso1001.visible = false;
		this.Garrafon001.visible = false;
		// this.Puerta_Mostrador.visible = false;
		// this.CodoContenedor01001.visible = false;
		// this.CodoContenedor02001.visible = false;
		// this.CodoContenedor03001.visible = false;
		// this.contenedor01Paso2001.visible = false;
		// this.contenedor02Paso2001.visible = false;
		// this.contenedor03Paso2001.visible = false;

		//* posiciones
		this.Cafetera001.position.x = -1.594;
		this.Cafetera_puerta.position.x = -1.574;
		this.Cafetera_letrero_andati.position.x = -1.574;
		this.Cafetera_contenedores_puerta.position.x = -1.5182;
		this.Mostrador.position.set(-0.15, 0.0067, 0.0294);
		this.Puerta_Mostrador.position.set(-0.3836, 0.4232, 0.1531);
		this.Garrafon001.position.set(-0.0754, 0.0112, 0.2544);
		this.CodoContenedor01001.position.x = -1.5923;
		this.CodoContenedor02001.position.x = -1.5226;
		this.CodoContenedor03001.position.x = -1.4426;
		this.contenedor01Paso2001.position.x = -1.5941;
		this.contenedor02Paso2001.position.x = -1.5941;
		this.contenedor03Paso2001.position.x = -1.5941;
		this.contenedor01Paso1001.position.x = -1.5941;
		this.contenedor02Paso1001.position.x = -1.5941;
		this.contenedor03Paso1001.position.x = -1.5941;

		this.Mostrador.position.set(-0.16, 0.007, 0);

		// this.Cafetera_puerta.position.set(-1.5735, 1.2399, 0.215);
		// this.Cafetera_puerta.rotation.set(-0.538, 0, 0);

		const materialBlack = new MeshLambertMaterial({ color: 0x000000 });
		this.contenedor02Paso1001.material = materialBlack;
		// this.contenedor02Paso1001.position.set(-1.294, 0, 0.9115);
		//* save materials objects
		this.objectsMaterials.beforeKeyMachine = this.Llave001;
		let objectKey = this.Llave001;
		const newMaterialKey = objectKey.material.clone();
		newMaterialKey.opacity = 1;
		newMaterialKey.transparent = true;
		this.objectsMaterials.keyMachine = newMaterialKey;

		this.objectsMaterials.beforeMostrador = this.Mostrador;
		let objectMostrador = this.Mostrador;
		const newMaterialMostrador = objectMostrador.material.clone();
		newMaterialMostrador.opacity = 1;
		newMaterialMostrador.transparent = true;
		this.objectsMaterials.keyMostrador = newMaterialMostrador;
		let objectCafeteraPuerta = this.Cafetera_puerta;
		const newMaterialCafeteraPuerta = objectCafeteraPuerta.material.clone();
		newMaterialCafeteraPuerta.opacity = 1;
		newMaterialCafeteraPuerta.transparent = true;
		this.objectsMaterials.beforeCafetera = newMaterialCafeteraPuerta;

		// this.helpersChild();
	}

	observerListtneners() {
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.tooltip.containerGrain, () => {
			this.ContenedorDeGrano.visible = true;
			this.ContenedorDeGrano.position.set(-1.7352, 1.5303, 0.3675);
			this.ContenedorDeGrano.rotation.y = 0.8895;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.tooltip.llave, () => {
			this.ContenedorDeGrano.visible = false;
			this.Llave003.visible = true;
			this.Llave003.position.set(-1.6352, 1.4625, 0.3675);
			this.Llave003.rotation.y = 0.8895;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.tooltip.pantalla, () => {
			this.Llave003.visible = false;
			this.Pantalla.visible = true;
			this.Pantalla.position.set(-1.6352, 1.3063, 0.3675);
			this.Pantalla.rotation.y = 0.8895;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.tooltip.botonselecion, () => {
			this.Pantalla.visible = false;
			this.BotonesDeSeleccion.visible = true;
			this.BotonesDeSeleccion.position.set(-1.5553, 1.2716, 0.3675);
			this.BotonesDeSeleccion.rotation.y = 0.8895;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.tooltip.dispensador, () => {
			this.BotonesDeSeleccion.visible = false;
			this.Dispensador001.visible = true;
			this.Dispensador001.position.set(-1.6352, 1.1198, 0.3675);
			this.Dispensador001.rotation.y = 0.8895;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.tooltip.charolaVaso, () => {
			this.Dispensador001.visible = false;
			this.CharolaPortaVaso.visible = true;
			this.CharolaPortaVaso.position.set(-1.5894, 1.0924, 0.3675);
			this.CharolaPortaVaso.rotation.y = 0.8895;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.tooltip.hiddenTooltip, () => {
			this.Dispensador001.visible = false;
			this.CharolaPortaVaso.visible = false;
			this.BotonesDeSeleccion.visible = false;
			this.Pantalla.visible = false;
			this.Llave003.visible = false;
			this.ContenedorDeGrano.visible = false;
			this.Dispensador001.position.set(0, 0, 0);
			this.CharolaPortaVaso.position.set(0, 0, 0);
			this.BotonesDeSeleccion.position.set(0, 0, 0);
			this.Pantalla.position.set(0, 0, 0);
			this.Llave003.position.set(0, 0, 0);
			this.ContenedorDeGrano.position.set(0, 0, 0);
		});

		// pasos de garrafon
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.stepUseMachineCoffe.stepOne, () => {
			this.onAnimationMoveCabinetCoffe();
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.animatioGarrafon, (step) => {
			this.onAnimationMoveGarrafon(step);
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.hiddenGarrafon, (step) => {
			this.Mostrador.visible = false;
			this.Puerta_Mostrador.visible = false;
			this.Garrafon001.position.set(0, 0, 0);
			this.Garrafon001.visible = false;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.eliminateAnimations, (step) => {
			this.eliminateAnimation();
		});

		// pasos de cafetera
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.stepUseMachineCoffe.stepTwo, () => {
			this.Llave001.visible = true;
			this.Llave001.position.set(-1.5729, 1.4181, 0.0527);
			// this.helperMethod("Llave001", this.Llave001.position, this.Llave001.rotation);
			this.onAnimate(this.Llave001);
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.animationKeyMachine, (step) => {
			this.onAnimationKey(step);
		});

		// paso de contenedores de cafe
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.stepUseMachineCoffe.stepThree, (step) => {
			this.stepActiveAnimation = step;
			this.onAnimate(this.contenedor03Paso2001);
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.stepUseMachineCoffe.stepFour, (step) => {
			this.onAnimationMoveContainer();
		});

		// paso 3 meter en vase
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.stepUseMachineCoffe.stepFive, (step) => {
			this.contenedor03Paso2001.visible = false; //antiguo
			this.contenedor03Paso2001.position.set(0, 0, 0);
			this.contenedor02Paso1001.position.set(-1.5218, 0, 0.0293);
			this.contenedor02Paso1001.visible = true; // negro
			this.onAnimate(this.contenedor02Paso1001);
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.visibleContainerStepFour, (step) => {
			this.eliminateAnimation();
			this.contenedor02Paso1001.position.set(0, 0, 0);
			this.contenedor02Paso1001.visible = false;
			this.contenedor03Paso1001.visible = true;
			this.contenedor03Paso1001.position.set(-2.1415, 0.1716, 0.9026);
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.stepUseMachineCoffe.stepSix, (step) => {
			this.onAnimationStepFourContainerCoffe(step);
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.stepUseMachineCoffe.stepSeven, (step) => {
			this.onAnimationStepSevenContainerCoffe(step);
		});
	}

	eliminateAnimation() {
		if (this.animation) {
			this.animation.kill();
		}
		if (this.animation1) {
			this.animation1.kill();
		}
	}

	onAnimationStepSevenContainerCoffe(step) {
		this.eliminateAnimation();
		this.Cafetera_puerta.material.emissive.set("#000000");
		gsap.to(this.Cafetera_puerta.rotation, {
			x: 0,
			duration: 1,
		});
		gsap.to(this.Cafetera_puerta.position, {
			y: 1.1599,
			z: 0.0945,
			duration: 1,
			onComplete: () => {
				this.Llave001.visible = true;
				this.Llave001.position.set(-1.5729, 1.4181, 0.0527);
				this.Llave001.material = this.objectsMaterials.beforeCafetera;
				gsap.to(this.Llave001.rotation, {
					y: 0,
					duration: 1,
					onComplete: () => {
						this.Llave001.visible = false;
						this.Llave001.position.set(0, 0, 0);
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.containerStepSevenFinish, step);
					},
				});
			},
		});
	}

	onAnimationStepFourContainerCoffe(step) {
		this.eliminateAnimation();
		this.animation = gsap.to(this.contenedor03Paso1001.position, {
			x: -1.5984,
			y: 0.0023,
			z: 0.0122,
			duration: 1,
			onComplete: () => {
				this.Cafetera_puerta.position.set(-1.5735, 1.2399, 0.215);
				this.Cafetera_puerta.rotation.set(-0.538, 0, 0);
				this.Cafetera_puerta.material = this.objectsMaterials.beforeCafetera;
				this.Cafetera_puerta.visible = true;
				ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.containerStepFourFinish, step);
			},
		});
	}

	onAnimationMoveContainer() {
		this.eliminateAnimation();
		this.contenedor03Paso2001.material.emissive.set("#000000");
		this.animation = gsap.to(this.contenedor03Paso2001.position, {
			x: -2.0626,
			y: 0.15223,
			z: 0.9115,
			duration: 1,
		});
	}

	onAnimationMoveGarrafon(step) {
		this.eliminateAnimation();
		let objectGarrafon = this.Garrafon001;
		const targets = {
			x: -1.294,
			y: 0.9115,
			z: 0.9115,
		};
		objectGarrafon.material.emissive.set("#000000");

		let objectMostrador = this.Mostrador;
		let objectPuerta = this.Puerta_Mostrador;
		objectMostrador.material = this.objectsMaterials.keyMostrador;
		objectPuerta.material = this.objectsMaterials.keyMostrador;
		gsap.to(objectMostrador.material, {
			opacity: 0,
			duration: 1,
			onComplete: () => {
				// objectMostrador.position.set(0, 0, 0);
				// objectPuerta.position.set(0, 0, 0);
			},
		});

		this.animation1 = gsap.to(objectGarrafon.position, {
			x: targets.x,
			y: targets.y,
			z: targets.z,
			duration: 1,
			onComplete: () => {
				ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.animatioGarrafonFinish, step);
			},
		});
	}

	onAnimationMoveCabinetCoffe() {
		this.eliminateAnimation();

		const targetMostradoZ = 0.2111;
		const targetPuerta = { z: 0.3295, x: -0.9432 };
		let objectMostrador = this.Mostrador;
		let objectPuerta = this.Puerta_Mostrador;
		this.animation = gsap.to(objectMostrador.position, {
			z: targetMostradoZ,
			duration: 1,
		});
		this.animation1 = gsap.to(objectPuerta.position, {
			z: targetPuerta.z,
			duration: 1,
			onComplete: () => {
				this.Garrafon001.visible = true;
				gsap.to(objectPuerta.position, {
					x: targetPuerta.x,
					duration: 1,
					onComplete: () => {
						this.onAnimate(this.Garrafon001);
					},
				});
			},
		});
	}

	onAnimationKey(step) {
		this.eliminateAnimation();

		let objectKey = this.Llave001;
		objectKey.material = this.objectsMaterials.keyMachine;
		objectKey.material.emissive.set("#000000");

		let objectDoor = this.Cafetera_puerta;
		objectDoor.material = this.objectsMaterials.keyMachine;

		const targetX = 1.6615; // Posición final en el eje x
		const targetY = -3.0805; // Posición final en el eje y

		this.animation = gsap.to(objectKey.rotation, {
			x: targetX,
			duration: 1,
			onComplete: () => {
				gsap.to(objectKey.rotation, {
					y: targetY,
					duration: 1,
					onComplete: () => {
						gsap.to(objectKey.material, {
							opacity: 0,
							duration: 1,
							onComplete: () => {
								objectKey.position.set(0, 0, 0);
								objectDoor.position.set(0, 0, 0);
								objectKey.visible = false;
								objectDoor.visible = false;
								ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.animationKeyMachineFinish, step);
							},
						});
					},
				});
			},
		});
	}

	onAnimate(object, previousObject) {
		this.eliminateAnimation();

		//*regresar el color al anterior
		this.beforeColor = object.material.emissive;
		if (previousObject !== undefined) {
			if (this[previousObject] !== undefined) {
				this[previousObject].material.emissive = this.beforeColor;
			}
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		object.material.emissive.set("#404040");

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	helpersChild() {
		const { position: positionLlave001, rotation: rotationLlave001 } = this.Llave001;
		this.helperMethod("Llave001", positionLlave001, rotationLlave001);
	}

	helperMethod(name, positions, rotation) {
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		folferMostrador.add(positions, "x", -20, 20).step(0.0001).name("Posición X");
		folferMostrador.add(positions, "y", -20, 20).step(0.0001).name("Posición Y");
		folferMostrador.add(positions, "z", -20, 20).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Cafetera kobalto");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this, "visible").name("Visible");
	}

	renderAnimations() { }
}
